// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__whElr","label":"Completed_label__B_k7w"};